import { render, staticRenderFns } from "./CinemaItem.vue?vue&type=template&id=385f033e&scoped=true&"
import script from "./CinemaItem.vue?vue&type=script&lang=js&"
export * from "./CinemaItem.vue?vue&type=script&lang=js&"
import style0 from "./CinemaItem.vue?vue&type=style&index=0&id=385f033e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f033e",
  null
  
)

export default component.exports